import { z } from 'zod';

/** Formulário de contato do site (RQ-INF-010). Campos a mais no corpo são descartados (o destino é fixo no servidor). */
export const esquemaContatoSite = z.object({
  nome: z.string().trim().min(2).max(200),
  email: z.string().trim().toLowerCase().email().max(254),
  telefone: z.string().trim().min(8).max(40),
  empresa: z.string().trim().max(200).optional(),
  /** Token assinado pelo servidor, pedido pelo site ao abrir o formulário. */
  token: z.string().max(4000).optional(),
  /** Token do reCAPTCHA v3 (ação `contato`). */
  recaptcha: z.string().max(4000).optional(),
});
export type ContatoSiteEntrada = z.infer<typeof esquemaContatoSite>;
